import { useInboxContext } from '@inbox/contexts';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const InboxCTA = () => {
    const { onOpenAddModal: handleOpenModal } = useInboxContext();

    return (
        <Box className="flex justify-end items-center bg-white rounded-xl px-5 py-2 mb-5 border border-neutral-200">
            <Button
                className="h-[40px] min-w-[216px] text-nowrap rounded-full"
                startIcon={<AddIcon />}
                onClick={handleOpenModal}
            >
                <Typography fontWeight={500} fontSize={15}>
                    New Inbox
                </Typography>
            </Button>
        </Box>
    );
};
